import api from "../../services/api";
import { getAvecCache } from "../../services/horsConnexion";

export const getTeacherDashboard = async () => {
  const response = await getAvecCache("teacher/dashboard/");
  return response.data;
};

export const getTeacherExamOptions = async () => {
  const response = await api.get("teacher/exams/options/");
  return response.data;
};

export const getTeacherAdminMessages = async () => {
  const response = await api.get("teacher/messages/", { params: { _: Date.now() } });
  return response.data;
};

export const sendTeacherAdminMessage = async ({ content, conversationId }) => {
  const payload = { content };
  if (conversationId) payload.conversation_id = conversationId;
  const response = await api.post("teacher/messages/", payload);
  return response.data;
};

// Solde lu en direct, jamais depuis le cache hors connexion (paiements).
export const getTeacherWalletBalance = async () => {
  const dashboard = (await api.get("teacher/dashboard/")).data;
  return dashboard.wallet || { balance: 0, currency: "FCFA" };
};

export const listTeacherWalletHistory = async ({ page = 1, pageSize = 10, type, status } = {}) => {
  const params = { page, page_size: pageSize };
  if (type) params.type = type;
  if (status) params.status = status;
  const response = await api.get("teacher/wallet/history/", { params });
  const data = response.data || {};
  return {
    count: Number(data.count) || 0,
    page: Number(data.page) || page,
    pageSize: Number(data.page_size) || pageSize,
    totalPages: Number(data.total_pages) || 0,
    next: data.next || null,
    results: Array.isArray(data.results) ? data.results : [],
  };
};

export const initializeTeacherWalletRecharge = async (amount) => {
  const response = await api.post("teacher/wallet/recharge/", { amount }, {
    timeout: 40000,
    skipAuthRetry: true,
  });
  return response.data;
};

export const getTeacherWalletRechargeStatus = async (rechargeId) => {
  const response = await api.get(`teacher/wallet/recharge/${rechargeId}/status/`);
  return response.data;
};

export const listTeacherExams = async ({ view, page = 1, pageSize = 10 } = {}) => {
  const params = { page, page_size: pageSize };
  if (view) params.view = view;
  const response = await getAvecCache("teacher/exams/", { params });
  const data = response.data || {};
  return {
    count: Number(data.count) || 0,
    page: Number(data.page) || page,
    pageSize: Number(data.page_size) || pageSize,
    totalPages: Number(data.total_pages) || 0,
    next: data.next || null,
    results: Array.isArray(data.results) ? data.results : [],
  };
};
